import { AbacoVuexModule, State } from "@abaco/web-common/src/app";
import { Process, ProcessTypeCollection, StatusListCollection } from './models/Processes';
import { Movement } from './models/Movements';
import { Anomaly } from './models/Anomalies';
import { PrintType } from './models/Prints';
import { FormCategory } from './models/Forms';

export default class ProcessesVuexModule extends AbacoVuexModule {

    @State() STORE_processSelected!: Process | null;
    @State({default: "home-index"}) STORE_processActiveTab!: string;
    @State({default: false}) STORE_showAnomalyModal!: boolean;

    @State({default: []}) STORE_processForms!: FormCategory[];
    @State({default: []}) STORE_processMovements!: Movement[];
    @State({default: []}) STORE_processAnomalies!: Anomaly[];
    @State({default: []}) STORE_processPrints!: PrintType[];
    @State({default: {}}) STORE_processTypes!: ProcessTypeCollection;
    @State({default: {}}) STORE_statusesList!: StatusListCollection;

    @State() processYearsNavbarFilterOpen!: boolean;

    @State({default: false}) hideMainMenu!: boolean;
    @State({default: false}) processEditAuth!: boolean;
    @State() backToModule!: string | null;

}
